import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {AppModule} from "./app/app.module";
import {Environment} from "./environments/Environment";

// bootstrapApplication(AppComponent, appConfig)
//   .catch((err) => console.error(err));

// Google Analytics script
// let script = document.createElement('script');
// script.async = true;
// script.src = 'https://www.googletagmanager.com/gtag/js?id=' + Environment.gaTagId;
// document.head.appendChild(script);
//
// script = document.createElement('script');
// script.classList.add('optanon-category-C0002');
// script.innerHTML = `window.dataLayer = window.dataLayer || [];
//                         function gtag(){dataLayer.push(arguments);}
//                         gtag('js', new Date());
//                         gtag('config',  '${Environment.gaTagId}' , {
//                             'client': 'Client Name',
//                             'event_type': 'Event Type',
//                             'event_category': 'Event Category',
//                             'event_action': 'Event Action',
//                             'event_label': 'Event Label',
//                             'user_id': 'User Id',
//                             'user_properties': {
//                                 'Name': 'User Name',
//                                 'Company': 'Company Name',
//                                 'Type': 'User Type',
//                                 'Role': 'User Role',
//                                 'Language': 'User Language',
//                                 },
//                                 });`;
// document.head.appendChild(script);


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => console.error(err));
